import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/data_infoset",
    name: "data_infoset",
    redirect: "/data_infoset/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "data_infoset_index",
        meta: {title: "信息集定义",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/data/infoset/index")
      }
    ]
  },
  {
    path: "/data_center",
    name: "data_center",
    redirect: "/data_center/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "data_center_index",
        meta: {title: "数据中心",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/data/center/index")
      }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/data.js